import type { EsgBoxConfig } from "./organization";

export type Feature =
  | "q_and_a"
  | "reports"
  | "public_api"
  | "user_admin"
  | "system_admin"
  | "contract_families"
  | "suppliers"
  | "spend_centre"
  | "renewal_centre"
  | "business_report_admin"
  | "organization_admin"
  | "superadmin"
  | "esg_portal"
  | "esg_user"
  | "document_authoring"
  | "open_chat"
  | "sharepoint";

export type PfRole = "organization_admin" | "business_report_admin" | "superadmin" | "esg_user";

export const PF_ROLES: readonly PfRole[] = [
  "esg_user",
  "business_report_admin",
  "organization_admin",
  "superadmin",
] as const;

export const PF_ROLE_LABELS: Record<PfRole, string> = {
  esg_user: "ESG user",
  business_report_admin: "Business report admin",
  organization_admin: "Organization admin",
  superadmin: "Superadmin",
};

export type DateFormat = "US" | "ISO" | "UK_EU" | "Verbose";
export type TimeFormat = "12h" | "24h";

export interface DirectoryUser {
  id: string;
  name: string;
  surname: string;
  email: string;
  avatar: string;
}

export interface Userdata {
  id: string;
  username: string;
  email: string;
  name: string;
  surname: string;
  phoneNumber: string;
  isActive: boolean;
  canSelfServiceEmailChange: boolean;
  avatar: string;
  organization: {
    id: string;
    name: string;
    features: Feature[];
    dateFormat: DateFormat;
    timeFormat: TimeFormat;
    esgPortalConfig: EsgBoxConfig[];
    contractFamilyDivisions?: string[];
  };
  features: Feature[];
  pfRoles: PfRole[];
  dateFormat: DateFormat;
  timeFormat: TimeFormat;
  /** Name stamped on AI tracked changes; null falls back to `<display name> (Pathfinder)`. */
  aiAuthorName?: string | null;
}
